module.exports = __webpack_public_path__ + "img/warning.378c2380.svg";